import { useDispatch, useSelector } from 'react-redux';
import { getShouldSendCsatSurveyLegacy } from '../actions/getShouldSendCsatSurvey';
import { selectActiveThreadId, selectShouldPollCsatSurvey } from '../selectors/chatSelectors';
import Raven from 'raven-js';
export const useShouldSendCsatSurveyLegacy = () => {
  const dispatch = useDispatch();
  const currentActiveThreadId = useSelector(selectActiveThreadId);
  const shouldPollCsatSurvey = useSelector(selectShouldPollCsatSurvey);
  if (!currentActiveThreadId || !shouldPollCsatSurvey) {
    return () => {};
  }
  return () => {
    return new Promise(resolve => {
      setTimeout(() => {
        dispatch(getShouldSendCsatSurveyLegacy({
          threadId: currentActiveThreadId
        })).unwrap().catch(error => {
          Raven.captureException(error, {
            extra: {
              component: 'useShouldSendCsatSurveyLegacy',
              action: 'getShouldSendCsatSurveyLegacy'
            }
          });
        }).finally(resolve);
      }, 5000); // 5 seconds delay to allow users to browse their latest response
    });
  };
};